export default function XPath_Axes() {
  return (
    <div>
      <h1>XPath_Axes</h1>
      <p>This is the XPath_Axes component.</p>
    </div>
  );
}